// extracted by mini-css-extract-plugin
export default {"container":"input-rfc_container__qtt7O","has-no-rfc-checkbox":"input-rfc_has-no-rfc-checkbox__CIfT+","checkbox-loader":"input-rfc_checkbox-loader__GMRv0"};